import type { Preferencia } from '@/services/preferencias.service';

const LOGO_PADRAO = 'logo-2023.png';
const LOGO_BRASAO_HEADER = 'logo-sefaz-branca.png';
const LOGO_BRASAO_FOOTER = 'logo-completa.png';

/** Flag de brasão oficial (configurações do sistema). */
export function isBrasaoOficialAtivo(
    source: Preferencia | { brasaoOficial?: boolean | null } | boolean | null | undefined
): boolean {
    if (typeof source === 'boolean') {
        return source;
    }
    if (source == null) {
        return false;
    }
    if ('brasaoOficial' in source) {
        return source.brasaoOficial === true;
    }
    return (source as Preferencia).brasaoOficial === true;
}

export function getHeaderLogoPath(brasaoOficial: boolean): string {
    const fileName = brasaoOficial ? LOGO_BRASAO_HEADER : LOGO_PADRAO;
    return `/assets/logos/${fileName}`;
}

export function getFooterLogoPath(brasaoOficial: boolean): string {
    const fileName = brasaoOficial ? LOGO_BRASAO_FOOTER : LOGO_PADRAO;
    return `/assets/logos/${fileName}`;
}
